import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import Chart from 'react-apexcharts';

const PieChart = ({ chartProps, ...props }) => {
    const theme = useTheme();
    const [graphState, setGraphState] = useState(updateState(chartProps, theme));
    useEffect(() => {
        setGraphState(updateState(chartProps, theme))
    }, [chartProps, theme])

    return (
        <Chart
            options={graphState.options}
            series={graphState.series}
            type='pie'
            width={'99.5%'}
            height={'99.5%'}
            
            style={{width: '100%'}}

        />
    );
}

export default PieChart;

const updateState = (chartProps, theme) => {
    return {
        series: chartProps.chartData,
        options: {
            chart: {
                type: 'pie',
            },
            colors: theme.chartArray,
            labels: chartProps.labels,
            legend: {
                position: chartProps.labelPos ?? 'right',
                labels: {
                    colors: theme.text,
                },
            },
        },
    };
}